// extracted by mini-css-extract-plugin
module.exports = {"privacyTitle":"style_privacyTitle__mcbqa","wrap":"style_wrap__3iqnD","title":"style_title__2QzRh","text":"style_text__hTn4g"};